import { render, staticRenderFns } from "./outbox.vue?vue&type=template&id=49cad79e&"
import script from "./outbox.vue?vue&type=script&lang=js&"
export * from "./outbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports